<template>
    <div>

        <rkm-form
            v-if="!!data"
            ref="FormFuncionalidade"
        >

            <rkm-form-checkbox-group v-model="model.funcionalidades">
                <rkm-form-checkbox
                    v-for="funcionalidade in funcionalidades"
                    :key="funcionalidade.id"
                    :value="funcionalidade.id"
                >
                    {{ funcionalidade.descricao }}
                </rkm-form-checkbox>
            </rkm-form-checkbox-group>
        </rkm-form>
    </div>
</template>

<script>

import { object } from '@/mixins'

export default {
    created: function() {

        this.load()
    },
    data: () => ({
        funcionalidades: [],
        form: null,
        model: {
            funcionalidades: [],
        },
    }),
    methods: {
        load() {

            this.funcionalidades = this.clone(this.data.model.faturamento.funcionalidades)

            var funcionalidadesAtivas = []

            this.funcionalidades.forEach(function(funcionalidade) {

                if (funcionalidade.faturar == 1) {

                    funcionalidadesAtivas.push(funcionalidade.id)
                }
            })

            this.model.funcionalidades = funcionalidadesAtivas
        },
    },
    mixins: [ object ],
    props: {
        data: { type: Object, required: false, },
    },
    watch: {
        'model.funcionalidades': function(funcionalidadesModel) {

            this.funcionalidades.forEach(function(funcionalidade) {

                if (!funcionalidadesModel.find(id => funcionalidade.id == id)) {
                    
                    funcionalidade.faturar = 0
                } else {

                    funcionalidade.faturar = 1
                }
            })

            this.data.model.faturamento.funcionalidades = this.funcionalidades
        }
    },
}

</script>